import FormControl from "components/Form/FormControl";
import { Seo } from "components/Seo";
import { FieldArray, useFormikContext } from "formik";
import { Company, ContactPoint } from "models/Company";
import { defaultContactPointsValues } from "models/DefaultCompanyValues";

const Links = () => {
  const { values, setFieldValue } = useFormikContext<Company | null>();

  const handlePaste = async (event: { preventDefault: () => void; clipboardData: any; }, name: string) => {
    event.preventDefault();
    const pastedText = await navigator.clipboard.readText();
    const trimmedText = pastedText.trim();
    setFieldValue(name, trimmedText);
  }

  return (
    <> <Seo title="Lenker" />
      {values === null ? (<p>Burde vært noe her</p>) : (<>
        <div className="mb-3">
          <label htmlFor="E-post" className="form-label">
            E-post
          </label>

          <FieldArray name="emails">
            {fieldArrayProps => {
              const { form } = fieldArrayProps;
              const { values } = form;
              const { emails } = values;
              return (
                <>{emails.length === 0 ? <>
                  <FormControl
                    type="email"
                    control="input"
                    name={`emails.[0].value`}
                    id="E-post"
                    onChange={(event: any) => { setFieldValue(`emails.[0].updated`, true); form.handleChange(event) }}
                    onPaste={(event: { preventDefault: () => void; clipboardData: any; }) => {setFieldValue(`emails.[0].updated`, true); handlePaste(event, `emails.[0].value`)}}
                  />
                </>
                  :
                  emails.map((cp: ContactPoint, index: number) => (
                    <FormControl
                      key={index}
                      type="email"
                      control="input"
                      name={`emails.[${index}].value`}
                      id={`E-post-${index}`}
                      onChange={(event: any) => { setFieldValue(`emails.[${index}].updated`, true); form.handleChange(event) }}
                      onPaste={(event: { preventDefault: () => void; clipboardData: any; }) => {setFieldValue(`emails.[${index}].updated`, true); handlePaste(event, `emails.[${index}].value`)}}
                    />
                  ))
                }
                </>
              )
            }}
          </FieldArray>
        </div>
        <div className="mb-3">
          <FieldArray name="urls">
            {fieldArrayProps => {
              const { form } = fieldArrayProps;
              const { values } = form;
              const { urls } = values;
              return (

                <><label htmlFor="Url-0" className="form-label">
                  Hjemmeside
                </label>
                  {urls.length === 0 ? <>

                    <FormControl
                      control="input"
                      type="text"
                      name={`urls.[0].value`}
                      id="Url-0"
                      onChange={(event: any) => { setFieldValue(`urls.[0].updated`, true); form.handleChange(event) }}
                      onPaste={(event: { preventDefault: () => void; clipboardData: any; }) => { setFieldValue(`urls.[0].updated`, true); handlePaste(event, `urls.[0].value`)}}
                    />
                  </>
                    :
                    urls.map((cp: ContactPoint, index: number) => (
                      <FormControl
                        control="input"
                        key={index}
                        type="text"
                        name={`urls.[${index}].value`}
                        id={`Url-${index}`}
                        onChange={(event: any) => { setFieldValue(`urls.[${index}].updated`, true); form.handleChange(event) }}
                        onPaste={(event: { preventDefault: () => void; clipboardData: any; }) => { setFieldValue(`urls.[${index}].updated`, true); handlePaste(event, `urls.[${index}].value`)}}
                      />
                    ))

                  }
                </>
              )
            }}
          </FieldArray>
        </div>
        <div className="mb-3">
          <label htmlFor="socialMediaUrls" className="form-label">
            Sosiale medier
          </label>
          <FieldArray name="socialMediaUrls">
            {fieldArrayProps => {
              const { push, form } = fieldArrayProps;
              const { values } = form;
              const { socialMediaUrls } = values;
              const defaultSoMeValue = defaultContactPointsValues();
              defaultSoMeValue.type = "Url";
              defaultSoMeValue.value = "";
              return (
                <>
                  {socialMediaUrls.map((cp: ContactPoint, index: number) => {
                    return (
                      <FormControl control="input" key={index} placeholder="Eks. Facebook, twitter, LinkedIn" name={`socialMediaUrls[${index}].value`} 
                       onChange={(event: any) => { setFieldValue(`socialMediaUrls.[${index}].updated`, true); form.handleChange(event); }}
                       onPaste={(event: { preventDefault: () => void; clipboardData: any; }) => {setFieldValue(`socialMediaUrls.[${index}].updated`, true); handlePaste(event, `socialMediaUrls[${index}].value`)}} />
                    )
                  })}
                  <p className="mb-3">
                    <button type="button" className="btn btn-light border" onClick={() => push(defaultSoMeValue)}>
                      <i className="bi bi-plus-lg"></i> Legg til flere sosiale medier
                    </button>
                  </p>
                </>
              )
            }}
          </FieldArray>
        </div></>)}
    </>
  )
}

export default Links